export const environment = {
  isReleaseBuild: true,
  envName: 'Project Three',
  isDev: true,
  enableDebug: false,
  swDebugLogging: true,
  swDebugLogLevel: 'error',
  swVersionPollingIntervalMs: 30000,
  swSuppressReadyToastWindowMs: 10000,
  useCache: false,
  useProxy: true,
  baseApiUrl: '/Services/MessengerProjThree/',
  host: 'https://mpluswsmo.energytransfer.com',
  port: ':443',
  secondaryUrl: 'https://mpluswsmo.energytransfer.com',
  infoPostBaseUrl: 'http://mo.peplmessenger.energytransfer.com/mo/ipost',
  extSecurityUrl: 'https://mo.security.energytransfer.net/',
  msal: {
    clientId: '4b4f2d99-6c76-48a7-aa25-f6def879833a',
    authority: 'https://login.microsoftonline.com/28fbb2af-a743-4fb9-8e66-24d90147e2ec',
    redirectUri: 'https://projthree.messenger.energytransfer.com',
    scope: '4b4f2d99-6c76-48a7-aa25-f6def879833a/access_as_user',
    protectedResourceURL: 'https://mpluswsmo.energytransfer.com/Services/MessengerProjThree'
  }
};
